import type { useGridApiRef } from '@mui/x-data-grid';
import { withDefault } from '@weft/utils';
import React, { useMemo } from 'react';
import { useArAgingReport } from '../../../../../hooks/requests/use-ar-aging-report';
import { useQueryInputParams } from '../../../../invoices/InvoicesPage/invoices-page-hooks/use-query-input-param';
import { ArAgingReportTable } from './ArAgingReportTable';

type ArAgingReportSectionProps = {
  apiRef?: ReturnType<typeof useGridApiRef>;
};

export const ArAgingReportSection: React.FC<ArAgingReportSectionProps> = ({ apiRef }) => {
  const { data: arAgingReport, isLoading: isLoadingArAgingReport } = useArAgingReport();
  const [query] = useQueryInputParams();

  const filteredSummary = useMemo(() => {
    const summary = withDefault(arAgingReport?.summary, []);

    return summary.filter((item) => {
      return item.customer.name.toLowerCase().includes(query?.toLowerCase() ?? '');
    });
  }, [arAgingReport, query]);

  return (
    <ArAgingReportTable
      apiRef={apiRef}
      items={filteredSummary}
      itemsCount={filteredSummary.length}
      loadingItems={isLoadingArAgingReport}
      showPagination={false}
      hideFooter={false}
      sx={{
        paddingBottom: '72px',
      }}
    />
  );
};